import { useQuery } from '@tanstack/react-query'

import { TypesenseClientInstance } from '../typesenseClient'
import { getTypesenseAuctionDetails } from './getTypesenseAuctionDetails'

export interface UseGetTypesenseAuctionDetailsParams {
  client: TypesenseClientInstance
  auctionId: number
}

export const useGetTypesenseAuctionDetails = ({
  client,
  auctionId,
}: UseGetTypesenseAuctionDetailsParams) =>
  useQuery({
    queryKey: ['auctions', { auctionId }],
    queryFn: () => getTypesenseAuctionDetails(client)({ id: auctionId }),
  })
